import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CTASection } from '../components/CTASection';
import { servicesContent } from '../data/content';
import { 
  Wrench, Sparkles, Laptop, Shirt, Mail, Home 
} from 'lucide-react';

const iconMap = {
  Wrench,
  Sparkles,
  Laptop,
  Shirt,
  Mail,
  Home
};

const ServicesPage = () => {
  return (
    <div data-testid="services-page" className="bg-white">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-orange-50 to-white relative overflow-hidden">
          <div className="absolute top-20 left-20 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl" />
          <div className="section-container relative z-10">
            <span className="inline-block px-4 py-2 bg-blue-100 text-blue-600 rounded-full text-sm font-semibold mb-4">
              At Your Service
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-slate-900 font-['Outfit'] mb-6">
              Resident <span className="text-coral">Services</span>
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl">
              {servicesContent.intro}
            </p>
          </div>
        </section>

        {/* Services Grid */}
        <section className="section-spacing bg-white">
          <div className="section-container">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {servicesContent.services.map((service, idx) => {
                const Icon = iconMap[service.icon] || Wrench;
                return (
                  <div
                    key={idx}
                    data-testid={`service-${idx}`}
                    className="group bg-white rounded-2xl p-8 border border-orange-100 hover:border-coral/30 hover:shadow-lg transition-all"
                  >
                    <div className="w-16 h-16 bg-slate-100 group-hover:bg-coral/10 rounded-2xl flex items-center justify-center mb-6 transition-colors">
                      <Icon className="w-8 h-8 text-slate-600 group-hover:text-coral transition-colors" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 font-['Outfit'] mb-3">
                      {service.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Support Section */}
        <section className="section-spacing bg-orange-50">
          <div className="section-container">
            <div className="bg-gradient-to-r from-coral to-orange rounded-3xl p-8 md:p-12 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white font-['Outfit'] mb-4">
                Need Assistance?
              </h2>
              <p className="text-white/90 text-lg max-w-xl mx-auto mb-8">
                Our resident support team is available to help you with any issues or requests. Just reach out!
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a
                  href="tel:016 933 4821"
                  className="inline-flex items-center gap-2 bg-white text-coral hover:bg-slate-100 px-8 py-4 rounded-full font-semibold transition-colors shadow-lg"
                >
                  Call Reception
                </a>
                <a
                  href="mailto:student@aplhouse.co.za"
                  className="inline-flex items-center gap-2 border-2 border-white text-white hover:bg-white/20 px-8 py-4 rounded-full font-semibold transition-colors"
                >
                  Email Support
                </a>
              </div>
            </div>
          </div>
        </section>

        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
